/**
 * LiveAudio (web) — le composant partagé avec le live du tuteur (`shared/live/LiveAudio.web`), à rendu
 * identique pour l'élève : le son en Dialogue seulement, la boîte « Touche pour réactiver le son ».
 */
export { LiveAudio } from "../../shared/live/LiveAudio.web"
